import {Component} from "@angular/core";

@Component({
    selector: 'app-dashboard',
    templateUrl: './office-board.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class OfficeBoardComponent {

    // Dashboard stats data
    stats = {
        objectiveToSort: 4904,
        termsToKeep: 20764,
        activitiesToManage: 687,
        conditionsToRestrict: 12836,
        domainSupported: 10635
    };

    // Navigation items
    navItems = [
        { icon: 'dashboard', label: 'Dashboard', route: '/dashboard', active: false },
        { icon: 'certificate', label: 'Certifications', route: '/certifications', active: true },
        { icon: 'association', label: 'Association', route: '/association', active: false },
        { icon: 'report', label: 'Report', route: '/report', active: false },
        { icon: 'settings', label: 'Settings', route: '/settings', active: false }
    ];

    // Tab navigation
    tabs = [
        { label: 'Overview', active: true },
        { label: 'Domains', active: false },
        { label: 'Objectives', active: false },
        { label: 'Conditions', active: false }
    ];

    constructor() { }

    onNavItemClick(item: any) {
        this.navItems.forEach(nav => nav.active = false);
        item.active = true;
    }

    onTabClick(tab: any) {
        this.tabs.forEach(t => t.active = false);
        tab.active = true;
    }
}
